class BrowserInfoHelper {
  isBrowserIE() {
    return ((navigator.userAgent.indexOf("MSIE") != -1) || (document.documentMode));
  }

  getBrowserName() {
    // console.log('[navigator.userAgent]',navigator.userAgent);
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return 'Firefox';
    } else if (navigator.userAgent.indexOf("Edge") != -1) {
      return 'Edge';
    } else if (navigator.userAgent.indexOf("Edg/") != -1) {
      return 'Edge';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf("Mozilla") != -1 && navigator.vendor.indexOf('Apple') > -1) {
      return 'Safari';
    } else if (this.isBrowserIE()) {
      return 'IE';
    } else {
      return 'unknown';
    }
  }

  getPlatform() {
    if (typeof device !== 'undefined' && device.platform) {
      return `${device.platform} ${device.version}`;
    } else {
      if (window.navigator.platform.indexOf('Win32') >= 0 || window.navigator.platform.indexOf('Win64') >= 0) {
        return 'Windows';
      }

      if (window.navigator.platform.indexOf('Linux') >= 0) {
        return 'Linux';
      }

      if (window.navigator.platform.indexOf('Mac') >= 0) {
        return 'Mac';
      }
    }

    return `${window.navigator.platform}`;
  }

  getScreenSize() {
    return `${window.screen.width} x ${window.screen.height}`;
  }
}

export default new BrowserInfoHelper();
